import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ChartLegendDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    }
});

export const useStyles = ({
    isToggleable,
    position,
    spaces
}: ChartLegendDynamicStyleType) => {
    const styles = {
        container: {
            columnGap: isToggleable ? spaces.spacingXxs : spaces.spacingMd,
            rowGap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    if(position === "top") {
        styles.container.marginBottom = spaces.spacingSm;
    } else {
        styles.container.marginTop = spaces.spacingSm;
    }

    if(isToggleable) {
        Object.assign(styles.container, {
            marginStart: -spaces.spacingSm
        });
    }

    return styles;
};
export default stylesheet;
